import React, {useEffect, useState} from 'react';
import './Avatar.css';


const Avatar = props => {

    const { REACT_APP_API_URL, REACT_APP_HFM_PLACEHOLDER_URL } = process.env;
   
    const [src, setSrc] = useState()

    useEffect(() => {
        setSrc(props.src);
    }, [ props.src]);

    return (
        <div className={`avatar-wrapper ${props.className}`}>
           <img 
            src={src ? `${REACT_APP_API_URL}/${src}` :  REACT_APP_HFM_PLACEHOLDER_URL} 
            alt={props.alt} 
            />
        </div>
    )
}

export default Avatar;